import React from "react";
import PropTypes from "prop-types";
import HDFComponent from "./HDFComponent";

const Questions = ({ label, components, ...props }) => {
  return (
    <div className="hdf-multi-question">
      <p>{label}</p>
      <div>
        {components &&
          components.map(comp => {
            return (
              <HDFComponent
                key={comp.id}
                style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }}
                comp={comp}
                {...props}
              />
            );
          })}
      </div>
    </div>
  );
};

Questions.propTypes = {
  label: PropTypes.string,
  hideLabel: PropTypes.bool,
  columns: PropTypes.number,
  components: PropTypes.array,
};

export default Questions;



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/Questions.js